module.exports = __webpack_public_path__ + "static/media/UniNeueThin-Italic.94508bef.woff2";